import HasID from "@/models/HasID";
import HasLabel from "@/models/HasLabel";
import TextUtils from "@/util/TextUtils";

export interface PatientPlan extends HasID {
    patientId: number | string,
    planId: number | string,
    memberId: number | string,
    groupId: number | string,
    cardholderId: number | string,
    personCode: string,
    relationshipCode: RelationshipCode,
    helpdeskNumber: string,
    coverageType: string;
    effectiveDate: Date,
    terminationDate: Date,
    active: boolean;
}

export enum RelationshipCode {
    NotSpecified = 0,
    Cardholder,
    Spouse,
    Child,
    Other,
}

export class PatientPlan extends HasLabel {
    constructor (ptPlan?: PatientPlan) {
        super();
        this.relationshipCode = RelationshipCode.Cardholder;
        if (ptPlan) {
            Object.assign(this, ptPlan);
        }
        if (ptPlan?.active === null || ptPlan?.active === undefined) this.active = true;
    }
    toString(): string {
        if (this.cardholderId) {
            return `Group: ${this.groupId}, Card: ${this.cardholderId}`;
        }
        return "";
    }

    get relationshipDesc():string {
        return PatientPlan.RelationshipToString(this.relationshipCode);
    }

    public static RelationshipToString(num:RelationshipCode):string{
        let res = RelationshipCode[num];
        res = TextUtils.camelCaseToNormal(res);

        return res;
    }
}

export enum PriorAuthorizationTypeCode {
    NotSpecified = 0,
    PriorAuthorization,
    MedicalCertification,
    EPSDT,
    ExemptionFromCopayAndOrCoinsurance,
    ExemptionFromRx,
    FamilyPlanningIndicator,
    TANF,
    PayerDefinedExemption,
    EmergencyPreparedness

}

export enum SubmissionClarificationCode {

    NoOverride = 1,
    OtherOverride = 2,
    VacationSupply = 3,
    LostDamagedPrescription = 4,
    TherapyChange = 5,
    StarterDose = 6,
    MedicallyNecessary = 7,
    ProcessCompoundForApprovedIngredients = 8,
    Encounters = 9,
    MeetsPlanLimitations = 10,
    CertificationOnFile = 11,
    DMEReplacementIndicator = 12,
    PayerRecognizedEmergencyDisasterAssistanceRequest = 13,
    LongTermCareLeaveofAbsence = 14,
    LongTermCareReplacementMedication = 15,
    LongTermCareEmergencyboxkitorautomateddispensingmachine = 16,
    LongTermCareEmergencysupplyremainder = 17,
    LongTermCarePatientAdmitReadmitIndicator = 18,
    SplitBilling = 19,
    Plan340B = 20,
    LTCdispensing14daysorlessnotapplicable = 21,
    LTCdispensing7days = 22,
    LTCdispensing4days = 23,
    LTCdispensing3days = 24,
    LTCdispensing2days = 25,
    LTCdispensing1day = 26,
    LTCdispensing4Then3days = 27,
    LTCdispensing2Then2Then3days = 28,
    LTCdispensingdailyand3dayweekend = 29,
    LTCdispensingPershiftdispensing = 30,
    LTCdispensingPermedpassdispensing = 31,
    LTCdispensingPRNondemand = 32,
    LTCdispensing7dayorlesscyclenototherwiserepresented = 33,
    LTCdispensing14daysdispensing = 34,
    LTCdispensing8To14daydispensingmethodnotlistedabove = 35,
    LTCdispensingdispensedoutsideshortcycle = 36,

    PrescribersDEAisactivewithDEAAuthorizedPrescriptiveRight = 43,

    PrescribersDEAisavalidHospitalDEAwithSuffixandhasprescriptiveauthorityforthisdrugDEASchedule = 45,
    PrescribersDEAhasprescriptiveauthorityforthisdrugDEASchedule = 46,
    ShortenedDaysSupplyFill = 47,
    FillSubsequenttoaShortenedDaysSupplyFill = 48,
    PrescriberdoesnotcurrentlyhaveanactiveType1NPI = 49,
    PrescribersactiveMedicareFeeForServiceenrollmentstatushasbeenvalidated = 50,
    PharmacysactiveMedicareFeeForServiceenrollmentstatushasbeenvalidated = 51,
    Prescribersstatelicensewithprescriptiveauthorityhasbeenvalidated = 52,
    PrescriberNPIactiveandvalid = 53,
    CMSOtherAuthorizedPrescriberOAP = 54,
    Other = 99,
}
